import React, { useEffect, useState } from "react";
import { dispatch, useSelector } from "../../redux/store";
import { getFlowerPackage } from "../../redux/action/flower-package";
import Loading from "../../global/item/Loading/loading";
import TitleComponent from "../../global/Custom/TitleComponent/TitleComponent";
import PackageItem from "./Components/PackageItem";

interface Props{
  packageId: number;
  title: string;
}
function PackageComponent({ packageId, title }: Props) {
  const { flowerPackageDetail } = useSelector((state) => state.flowerPackage);
  console.log("flowerPackageDetail", flowerPackageDetail);
  

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        await dispatch(getFlowerPackage(packageId));
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [packageId]); 

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div>
          <TitleComponent
            title={title}
            type="primary"
            
          />
          {flowerPackageDetail && flowerPackageDetail.flowers != null && flowerPackageDetail.flowers.length > 0 ? (
            <PackageItem flower={flowerPackageDetail.flowers} packageId={packageId} />
          ) : (
            <p>Không có hoa nào trong gói này.</p>
          )}
        </div>
      )}
    </div>
  );
}

export default PackageComponent;
